import { createAsyncThunk } from '@reduxjs/toolkit';
import * as contestApi from '../../api/contest';

export const getContestList = createAsyncThunk('getContestList', async (data) => {
    const res = await contestApi.getContestList({ data: data });
    return res.data;
});

export const deleteContest = createAsyncThunk('deleteContest', async (data) => {
    const res = await contestApi.deleteContest({ data: data });
    return res.data;
});
export const getContestTypes = createAsyncThunk('getContestTypes', async (data) => {
    const res = await contestApi.getContestTypes({ data: data });
    return res.data;
});
export const updateContestOrder = createAsyncThunk('updateContestOrder', async (ids) => {
    const res = await contestApi.updateContestOrder({
        options: {
            params: { Ids: ids },
        },
    });
    return res.data;
});

